import './css/App.css'
import { useEffect } from 'react'

import StackNavigator from './components/templates/stackNavigator'
import initialize from './utils/general/initialize'
import { observer } from 'mobx-react'
import backendApis from './utils/backendApis'
import AuthStore from './stores/AuthStore'

let generatingToken = false

const App = observer(() => {
  // 로컬스토리지에서 token이 있는지 확인하고, 없으면 새로운 objectId 기반으로 token 생성
  const token = localStorage.getItem('token')

  useEffect(() => {
    const setToken = async () => {
      if (!token || token === 'undefined') {
        if (!generatingToken) {
          generatingToken = true
          try {
            const utmParams = new URLSearchParams(window.location.search) || {}
            const insertedInfo = await backendApis.generateToken({
              utmParams: Object.fromEntries(utmParams?.entries()),
            })

            AuthStore.setToken(insertedInfo?.data?.token)
            localStorage.setItem('token', insertedInfo?.data?.token)
            localStorage.setItem('userId', insertedInfo?.data?.userId)

            window.location.reload()
          } finally {
            generatingToken = false
          }
        }
      } else {
        AuthStore.setToken(token)
      }
    }

    setToken()
  }, [token])

  const isDevMode = false

  useEffect(() => {
    if (!AuthStore.token) {
      return
    }

    initialize.init(AuthStore.token)
  }, [token])

  return <StackNavigator />
})

export default App
